import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { Applicant } from '../../redux-store/types/api-types';
import { KeyValue } from './contributor';
import { Gridstyles } from './index';
import { SubHeading } from '../investors/components';
import {
  checkAddressField,
  checkValidationBasedOnDate,
  isCustodianHDFC,
  isCustodianICICIOrHDFC,
  isCustodianNuvuma,
  isCustodianSparkPwm,
} from '../../utils/utilityFunctions';
import { ContactRelations, ContactRelationsForHDFC } from '../../utils/constant';
import { useValidationOrConfigHook } from '../../utils/validationOrConfigHook';
import { isSelfDeclaration } from '../investors/contactDetails';

export default function ContactDetails({
  applicants = [],
  custodian = '',
  createdAt = '',
}: {
  applicants: Partial<Applicant>[];
  custodian: string;
  createdAt: string;
}): JSX.Element {
  const { kraApplicableDate } = useValidationOrConfigHook();
  const isKraApplicable = checkValidationBasedOnDate(createdAt, kraApplicableDate);
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
              Contact Details
            </Typography>
            {applicants.map((applicant, index: number) => {
              const title = [
                'First Applicant Details',
                'Second Applicant Details',
                'Third Applicant Details',
              ][index];
              return (
                <React.Fragment key={applicant.id}>
                  <SubHeading sx={{ color: 'common.black', letterSpacing: 0.5 + 'px' }}>
                    {title}
                  </SubHeading>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pt={2}
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={13}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue title={'E-Mail ID'} description={applicant.email} />
                      {isCustodianHDFC(custodian) && !isKraApplicable && (
                        <KeyValue
                          title={'This Email Id Belongs To?'}
                          description={ContactRelationsForHDFC[applicant.emailDeclaration || '']}
                        />
                      )}
                      <KeyValue
                        title={'Mobile Number'}
                        description={
                          applicant.countryCode
                            ? applicant.countryCode + '-' + applicant.mobile
                            : applicant.mobile
                        }
                      />

                      {isCustodianHDFC(custodian) && !isKraApplicable && (
                        <KeyValue
                          title={'This Mobile Number Belongs To?'}
                          description={ContactRelationsForHDFC[applicant.mobileDeclaration || '']}
                        />
                      )}
                      {isCustodianNuvuma(custodian) && (
                        <KeyValue
                          title={`${
                            isKraApplicable ? 'KRA' : 'This'
                          } Email Id & Mobile No Belongs To?`}
                          description={ContactRelations[applicant.mobileEmailDeclaration || '']}
                        />
                      )}
                      {(applicant.kraMobileNumber || isKraApplicable) && (
                        <KeyValue
                          title={'KRA Mobile Number'}
                          description={applicant.kraMobileNumber}
                        />
                      )}
                      {(isCustodianHDFC(custodian || '') || isCustodianSparkPwm(custodian || '')) &&
                        isKraApplicable && (
                          <KeyValue
                            title={'KRA Mobile Number Belongs To?'}
                            description={ContactRelationsForHDFC[applicant.mobileDeclaration || '']}
                          />
                        )}
                      {isCustodianSparkPwm(custodian || '') &&
                        !isSelfDeclaration(applicant.mobileDeclaration || '') && (
                          <KeyValue
                            title={'Name of Family Member (Phone)'}
                            description={applicant.kraNumberBelongsToName}
                          />
                        )}
                      {(applicant.kraEmail || isKraApplicable) && (
                        <KeyValue title={'KRA E-Mail ID'} description={applicant.kraEmail} />
                      )}
                      {(isCustodianHDFC(custodian || '') || isCustodianSparkPwm(custodian || '')) &&
                        isKraApplicable && (
                          <KeyValue
                            title={'KRA Email Id Belongs To?'}
                            description={ContactRelationsForHDFC[applicant.emailDeclaration || '']}
                          />
                        )}
                      {isCustodianSparkPwm(custodian || '') &&
                        !isSelfDeclaration(applicant.emailDeclaration || '') && (
                          <KeyValue
                            title={'Name of Family Member (E-Mail)'}
                            description={applicant.kraEmailBelongsToName}
                          />
                        )}
                      <KeyValue
                        title={'Phone Number (Office)'}
                        description={applicant.phoneNumberoffice}
                      />
                      <KeyValue
                        title={'Phone Number (Residential)'}
                        description={applicant.phoneNumberResidence}
                      />
                      {!!applicant?.addresses?.length &&
                        applicant?.addresses.map((address) => (
                          <React.Fragment key={address.id}>
                            <KeyValue
                              title={`${address.address_type} Address`}
                              description={`${checkAddressField(
                                address.address1
                              )}${checkAddressField(address.address2)}${checkAddressField(
                                address.address3
                              )}
                              ${checkAddressField(address.city)}${
                                isCustodianICICIOrHDFC(custodian) || isCustodianSparkPwm(custodian)
                                  ? checkAddressField(address.district)
                                  : ''
                              }${checkAddressField(address.state)}${checkAddressField(
                                address.country
                              )}${address.pincode}`}
                              sx={{
                                textTransform: 'capitalize',
                              }}
                            />
                          </React.Fragment>
                        ))}
                    </Grid>
                  </Gridstyles>
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
